import Link from "next/link";
import { usePathname } from "next/navigation";
import NotificationDot from "./NotificationDot";
import { NavItem } from "@/types";
import { memo } from "react";

const FullNavItem = memo(({ item, onClick }: { item: NavItem; onClick?: () => void }) => {
  const pathname = usePathname();
  const isActive = pathname === item.href;

  return (
    <Link href={item.href} onClick={onClick} prefetch={false}>
      <div className={`
        flex items-center gap-3 px-4 py-2.5 rounded-lg mx-2
        text-sm font-medium transition-colors duration-150 cursor-pointer
        ${isActive ? 'bg-blue-500 text-white' : 'text-slate-300 hover:bg-white/10'}
      `}>
        <span className={`shrink-0 ${isActive ? 'text-white' : 'text-slate-400'}`}>
          {item.icon}
        </span>
        <span className="flex-1 truncate">{item.label}</span>
        {item.hasNotification && <NotificationDot />}
      </div>
    </Link>
  );
});

export default FullNavItem;